import { FILE_TYPE } from "../constant/toothConstant";

const isMacOSJunkPath = (p) =>
  p.startsWith("__MACOSX/") ||
  p.includes("/__MACOSX/") ||
  p.endsWith("/.DS_Store") ||
  p.endsWith(".DS_Store")

export const convertFileResourceFromZip = (zip) => {
  const zipMap = zip.files;
  const fileList = Object.entries(zipMap)
    .filter(([key, value]) => !value.dir && !isMacOSJunkPath(key))
    .map(([key, value]) => {
      return {
        key,
        type: FILE_TYPE.ZIP,
        path: key,
        file: value,
      };
    });

  return fileList;
};
